import React, { Component } from 'react';
import Panel from '../../../../../../components/angle/Panel/index';
import { Tabs, Tab } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import AddClassForm from '../../../../components/ClassForm';

import {
    addNewClass,
    updateAddNewClassPayload,
    handleAddClassVisibility
} from '../../../../../../services/redux/employee/classes/actions';
import { formInputValidation } from '../../../../../../services/helper/form-helper';

class AddClass extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }
    
    onSubmitClick = () => {
        let { 
            classes, 
            addNewClass, 
            handleAddClassVisibility, 
            parentPortfolio 
        } = this.props;
        let payload = {...classes.addNewClass, portfolioId: parentPortfolio.value};
        if (formInputValidation(this.formRef.current)) {
            addNewClass(payload).then(response => {
                if (response.status === 200) {
                    handleAddClassVisibility(false);
                }
            });
        }
    };

    onCancelClick = () => {
        let { handleAddClassVisibility } = this.props;
        handleAddClassVisibility(false);
    };

    render() {

        let { classes, updateAddNewClassPayload } = this.props;
        let submitButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSubmitClick}
            >
                Submit
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Back
            </button>
        );

        const buttonList = [submitButton, cancelButton];

        return (
            <div role="tabpanel" className="panel col-md-6 mb">
                <Tabs defaultActiveKey={1} id="tabID">
                    <Tab eventKey={1} title="Add Class">
                        <Panel showFooter footerComponents={buttonList}>
                            <div>
                                <AddClassForm
                                    classData={classes.addNewClass}
                                    updateClassData={
                                        updateAddNewClassPayload
                                    }
                                    formRef={this.formRef}
                                />
                            </div>
                        </Panel>
                    </Tab>
                </Tabs>
                {classes.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    classes: state.employee.classes
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            addNewClass,
            updateAddNewClassPayload,
            handleAddClassVisibility
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AddClass));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/NewRequest/screens/AddClass/index.js